import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isCurrentDay", "size", "textProps"];
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { useTheme } from '../lib/styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const DateMarker = _ref => {
  let {
      children,
      isCurrentDay,
      size,
      textProps
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    backgroundColor: isCurrentDay ? theme.uiAddonCalendars.dayCurrentDateMarkerBackground : undefined,
    borderRadius: isCurrentDay ? 'full' : undefined,
    justifyContent: "center",
    alignItems: "center",
    inlineSize: size,
    blockSize: size
  }, props, {
    children: /*#__PURE__*/_jsx(Text, Object.assign({
      typography: "heading-25"
    }, textProps, isCurrentDay ? {
      color: 'fill-surface-default'
    } : undefined, {
      children: children
    }))
  }));
};